// CUNY Hunter College's bachelor's majors (#2743). Read on 2026-10-01 from
// the official Hunter College Undergraduate Catalog (Coursedog,
// hunter-undergraduate.catalog.cuny.edu): the Programs list (185 active
// undergraduate programs, read through the catalog page's own program search
// with the page size raised), keeping type "Major" with a bachelor's degree
// designation (BA, BS, BFA, BMUS, BSW, written as the catalog abbreviates
// them). Grouped by the owning department, as the catalog assigns it, each
// group citing that department's catalog page; Religion and Social Sciences
// have no department page in the catalog's list, so they cite the Programs
// page. Left out: 22 combined bachelor's and master's programs (BA/MA,
// BS/MS, BA/MS, BS/MA, BS/MS/MPH), 5 certificates and 76 minors.
// The four Nursing BS pathways share the display name "Nursing"; they are
// told apart here by their catalog long names (Generic Pathway, Accelerated
// Generic Pathway, QCC Pathway, RN Pathway). Display names are the
// catalog's, including "Biological Sciences Major 1", "Chemistry Major 1/2"
// and the size labels on Art History, Studio Art and Music, where the
// catalog's "(30 credit major)" is written "(30 semester hours)" to keep the
// page's no-"credit" copy rule.
// The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "cuny-hunter-college",
    "read": "2026-10-01",
    "intro": "Every bachelor's major in Hunter's official undergraduate catalog, grouped by the department that owns it, with the degree it leads to. Combined bachelor's and master's programs, minors and certificates are left out.",
    "groups": [
        {
            "name": "Africana, Puerto Rican and Latino Studies",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Africana, Puerto Rican and Latino Studies",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/AFR-HTR/overview"
            },
            "majors": [
                {
                    "name": "Africana and Puerto Rican/Latino Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Anthropology",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Anthropology",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/ANTH-HTR/overview"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Art & Art History",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Art & Art History",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/ART-HTR/overview"
            },
            "majors": [
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Art History (30 semester hours)",
                    "degree": "BA"
                },
                {
                    "name": "Studio Art (24 semester hours)",
                    "degree": "BA"
                },
                {
                    "name": "Studio Art (42 semester hours)",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Biological Sciences",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Biological Sciences",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/BIO-HTR/overview"
            },
            "majors": [
                {
                    "name": "Biological Sciences Major 1",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Chemistry",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Chemistry",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/CHEM-HTR/overview"
            },
            "majors": [
                {
                    "name": "Chemistry Major 1",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry Major 2",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Classical and Oriental Studies",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Classical and Oriental Studies",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/CLASS-HTR/overview"
            },
            "majors": [
                {
                    "name": "Arabic",
                    "degree": "BA"
                },
                {
                    "name": "Archaeology",
                    "degree": "BA"
                },
                {
                    "name": "Archaeology (Interdepartmental)",
                    "degree": "BA"
                },
                {
                    "name": "Chinese Language and Literature",
                    "degree": "BA"
                },
                {
                    "name": "Classical Studies",
                    "degree": "BA"
                },
                {
                    "name": "Greek",
                    "degree": "BA"
                },
                {
                    "name": "Hebrew",
                    "degree": "BA"
                },
                {
                    "name": "Japanese Language and Culture",
                    "degree": "BA"
                },
                {
                    "name": "Latin",
                    "degree": "BA"
                },
                {
                    "name": "Latin and Greek",
                    "degree": "BA"
                },
                {
                    "name": "Russian",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Computer Science",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Computer Science",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/CSCI-HTR/overview"
            },
            "majors": [
                {
                    "name": "Computer Science",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Dance",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Dance",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/DAN-HTR/overview"
            },
            "majors": [
                {
                    "name": "Dance",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Economics",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Economics",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/ECON-HTR/overview"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "English",
            "source": {
                "label": "Hunter College Undergraduate Catalog, English",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/ENGL-HTR/overview"
            },
            "majors": [
                {
                    "name": "English",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Film and Media Studies",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Film and Media Studies",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/FILM-HTR/overview"
            },
            "majors": [
                {
                    "name": "Film",
                    "degree": "BA"
                },
                {
                    "name": "Media Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Geography and Environmental Science",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Geography and Environmental Science",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/GEOG-HTR/overview"
            },
            "majors": [
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "German",
            "source": {
                "label": "Hunter College Undergraduate Catalog, German",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/GER-HTR/overview"
            },
            "majors": [
                {
                    "name": "German",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "History",
            "source": {
                "label": "Hunter College Undergraduate Catalog, History",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/HIST-HTR/overview"
            },
            "majors": [
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "International Affairs",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Human Biology",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Human Biology",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/HMBIOL-HTR/overview"
            },
            "majors": [
                {
                    "name": "Human Biology",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Mathematics and Statistics",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Mathematics and Statistics",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/MATH-HTR/overview"
            },
            "majors": [
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Medical Laboratory Sciences",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Medical Laboratory Sciences",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/MLS-HTR/overview"
            },
            "majors": [
                {
                    "name": "Medical Lab Sciences: Biomedical Science",
                    "degree": "BS"
                },
                {
                    "name": "Medical Laboratory Sciences: Clinical Science",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Music",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Music",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/MUS-HTR/overview"
            },
            "majors": [
                {
                    "name": "Music",
                    "degree": "BMUS"
                },
                {
                    "name": "Music (25 semester hours)",
                    "degree": "BA"
                },
                {
                    "name": "Music (42 semester hours)",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Nutrition and Public Health",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Nutrition and Public Health",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/NPH-HTR/overview"
            },
            "majors": [
                {
                    "name": "Nutrition and Food Science: Dietetics",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition and Wellness",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Philosophy",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Philosophy",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/PHIL-HTR/overview"
            },
            "majors": [
                {
                    "name": "Philosophy",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Physics and Astronomy",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Physics and Astronomy",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/PHYS-HTR/overview"
            },
            "majors": [
                {
                    "name": "Physics",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Political Science",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Political Science",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/POLSCI-HTR/overview"
            },
            "majors": [
                {
                    "name": "Political Science",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Psychology",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Psychology",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/PSYCH-HTR/overview"
            },
            "majors": [
                {
                    "name": "Psychology",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Religion",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Programs",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/programs"
            },
            "majors": [
                {
                    "name": "Religion",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Romance Languages",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Romance Languages",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/ROMLAN-HTR/overview"
            },
            "majors": [
                {
                    "name": "Comparative Literature",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Romance Languages",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "Hunter College Undergraduate Catalog, School of Education",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/EDUC-HTR/overview"
            },
            "majors": [
                {
                    "name": "Biology, Grades 7-12",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry, Grades 7-12",
                    "degree": "BA"
                },
                {
                    "name": "Childhood Education, Grades 1-6 Quest",
                    "degree": "BA"
                },
                {
                    "name": "Chinese, Grades 7-12",
                    "degree": "BA"
                },
                {
                    "name": "Dance, Grades Pre K-12",
                    "degree": "BA"
                },
                {
                    "name": "Early Childhood Education, Birth to Grade 2nd",
                    "degree": "BA"
                },
                {
                    "name": "English, Grades 7-12",
                    "degree": "BA"
                },
                {
                    "name": "French, Grades 7-12",
                    "degree": "BA"
                },
                {
                    "name": "German, Grades 7-12",
                    "degree": "BA"
                },
                {
                    "name": "Hebrew, Grades 7-12",
                    "degree": "BA"
                },
                {
                    "name": "Italian, Grades 7-12",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics, Grades 7-12",
                    "degree": "BA"
                },
                {
                    "name": "Physics, Grades 7-12",
                    "degree": "BA"
                },
                {
                    "name": "Russian, Grades 7-12",
                    "degree": "BA"
                },
                {
                    "name": "Social Studies, Grades 7-12 - Geography",
                    "degree": "BA"
                },
                {
                    "name": "Social Studies, Grades 7-12 - History",
                    "degree": "BA"
                },
                {
                    "name": "Spanish, Grades 7-12",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Nursing",
            "source": {
                "label": "Hunter College Undergraduate Catalog, School of Nursing",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/NURSE-HTR/overview"
            },
            "majors": [
                {
                    "name": "Nursing, Accelerated Generic Pathway",
                    "degree": "BS"
                },
                {
                    "name": "Nursing, Generic Pathway",
                    "degree": "BS"
                },
                {
                    "name": "Nursing, QCC Pathway",
                    "degree": "BS"
                },
                {
                    "name": "Nursing, RN Pathway",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Social Sciences",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Programs",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/programs"
            },
            "majors": [
                {
                    "name": "Jewish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latin American and Caribbean Studies",
                    "degree": "BA"
                },
                {
                    "name": "Special Honors Program",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Social Work",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Social Work",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/SW-HTR/overview"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "BSW"
                }
            ]
        },
        {
            "name": "Sociology",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Sociology",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/SOC-HTR/overview"
            },
            "majors": [
                {
                    "name": "Sociology",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Theatre",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Theatre",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/THR-HTR/overview"
            },
            "majors": [
                {
                    "name": "Theatre",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Urban Policy and Planning",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Urban Policy and Planning",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/URBAF-HTR/overview"
            },
            "majors": [
                {
                    "name": "Urban Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Women and Gender Studies",
            "source": {
                "label": "Hunter College Undergraduate Catalog, Women and Gender Studies",
                "url": "https://hunter-undergraduate.catalog.cuny.edu/departments/WGS-HTR/overview"
            },
            "majors": [
                {
                    "name": "Women and Gender Studies",
                    "degree": "BA"
                }
            ]
        }
    ]
};

export default majors;
